import { Box, Divider, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactSortable } from "react-sortablejs";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import DayPicker from "Components/DayPicker";
import { deselectStation, setStations } from "Redux/stationsSlice";
import type { IStepProps } from ".";

export default function General({ data, setData }: IStepProps) {
  const { stations } = useAppSelector((state) => state.stations);
  const dispatch = useAppDispatch();

  const stepData = data?.general || null;

  return (
    <>
      <Grid container columnSpacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs={3}>
          <TextField label="نام خط" fullWidth onChange={(e) => setData("name", e.target.value)} value={stepData?.name || ""} />
        </Grid>
        <Grid item xs={6}>
          <DayPicker
            label="روزهای فعالیت"
            multiple
            padding="15px"
            minWidth={50}
            isGeneral={true}
            value={stepData?.working_days || []}
            setData={(value) => setData("working_days", value)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField label="کد خط" fullWidth onChange={(e) => setData("code", e.target.value)} value={stepData?.code || ""} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />

      <Typography fontWeight="800" variant="h5" mb={2}>
        ترتیب ایستگاه‌ها
      </Typography>

      <Stack spacing={1} sx={{ height: "50vh", overflowY: "scroll" }}>
        <ReactSortable
          onStart={(e) => {}}
          filter=".addImageButtonContainer"
          dragClass="sortableDrag"
          list={stations.map((x) => ({ ...x, chosen: true }))}
          setList={(currentList) => {
            dispatch(setStations(currentList));
          }}
          animation={200}
          easing="ease-out"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {stations.map((station, index) => (
            <>
              <Grid container alignItems="center" justifyContent="space-between" mb={1}>
                <Grid item>
                  <Typography className="fa-number" fontWeight="700" fontSize="20px">
                    {index + 1}
                  </Typography>
                </Grid>
                <Grid item xs={10.5}>
                  <Box sx={{ p: 2, border: "1px solid #aaa", borderRadius: 1, flexGrow: 1 }}>{station.title}</Box>
                </Grid>
                <Grid item xs={0.7}>
                  <IconButton onClick={() => dispatch(deselectStation(station.id))}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </>
          ))}
        </ReactSortable>
      </Stack>
    </>
  );
}
